export default __webpack_public_path__ + "static/media/16_Have-a-dance_Share.99c26c68.jpg";